import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { formatUpdatedAgo } from '../../../common/utils/item-util';

export class EventDetail extends Component {
  render() {
    const { event, projectId, version } = this.props;
    const { eventTitle, uuid, updatedAt } = event;
    const updatedAgo = formatUpdatedAgo(updatedAt);
    return (
      <Fragment>
        <Link
          to={`/2.0/events/${version}/v/${projectId}/event/${uuid}`}
          className={`list-group-item list-group-item-action align-items-center`}
          style={{ cursor: 'pointer', float: 'left' }}
        >
          <i className="gjs-caret-icon wb webconnect-diagram-2-fill"></i>&nbsp;{eventTitle}
          <br />
          <small className="text-muted ml-3">{`Updated ${updatedAgo}`}</small>
        </Link>
      </Fragment>
    );
  }
}

EventDetail.propTypes = {
  event: PropTypes.object.isRequired,
};

export default EventDetail;
